export const STRIPE_PUBLISHABLE_KEY_REQUEST = "STRIPE_PUBLISHABLE_KEY_REQUEST";
export const STRIPE_PUBLISHABLE_KEY_SUCCESS = "STRIPE_PUBLISHABLE_KEY_SUCCESS";
export const STRIPE_PUBLISHABLE_KEY_FAIL = "STRIPE_PUBLISHABLE_KEY_FAIL";
export const STRIPE_PUBLISHABLE_KEY_RESET = "STRIPE_PUBLISHABLE_KEY_RESET";
